import React, { Component, useState } from "react";
import "leaflet/dist/leaflet.css";

export default function ValueChain() {
  return (
    <table className="KPIs-table">
      <tr>
        <th>Strategic Imperative</th>
        <th>KPI</th>
        <th>Unit</th>
        <th>Weight (%)</th>
        <th>
          <div>Target</div>
          <div>YTD</div>
        </th>
        <th>
          <div>Actual</div>
          <div>YTD</div>
        </th>
        <th>%Achieved</th>
        <th>Score</th>
        <th>
          <div>Actual</div>
          <div>Jan</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Feb</div>
        </th>
        <th>
          <div>Mar</div>
          <div>Jan</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Apr</div>
        </th>
        <th>
          <div>Actual</div>
          <div>May</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Jun</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Jul</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Aug</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Sep</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Oct</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Nov</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Dec</div>
        </th>
      </tr>
      <tr className="table-collapse">
        <td
          style={{
            border: "none",
            background: "#e28f60",
            whiteSpace: "nowrap",
          }}
        >
          ลดต้นทุนตลอด Value Chain
        </td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
      </tr>
      <tr style={{ textAlign: "center" }}>
        <td>ลดต้นทุนวัตถุดิบ </td>
        <td>% ส่วนต่างของต้นทุนวัตถุดิบ/กก</td>
        <td>%</td>
        <td>3.0%</td>
        <td>1%</td>
        <td>19%</td>
        <td>(1,944%)</td>
        <td>1</td>
        <td>20%</td>
        <td>21%</td>
        <td>22%</td>
        <td>18%</td>
        <td>19%</td>
        <td>20%</td>
        <td>21%</td>
        <td>21%</td>
        <td>17%</td>
        <td>17%</td>
        <td>17%</td>
        <td>16%</td>
      </tr>
      <tr style={{ textAlign: "center" }}>
        <td>ลดค่าใช้จ่ายผลิต</td>
        <td>% ส่วนต่างของ คชจ. ผลิต/กก</td>
        <td>%</td>
        <td>2.0%</td>
        <td>(0%)</td>
        <td>6%</td>
        <td>(1,613%)</td>
        <td>1</td>
        <td>4%</td>
        <td>2%</td>
        <td>3%</td>
        <td>(2%)</td>
        <td>4%</td>
        <td>5%</td>
        <td>8%</td>
        <td>13%</td>
        <td>19%</td>
        <td>6%</td>
        <td>5%</td>
        <td>0%</td>
      </tr>
      <tr style={{ textAlign: "center" }}>
        <td>ลดค่าใช้จ่ายการดำเนินงาน (SG&A)</td>
        <td>% ค่าใช้จ่ายดำเนินงาน (SG&A)</td>
        <td>% ต่อยอดขาย</td>
        <td>2.0%</td>
        <td>2%</td>
        <td>2%</td>
        <td>108%</td>
        <td>4</td>
        <td>2%</td>
        <td>3%</td>
        <td>2%</td>
        <td>2%</td>
        <td>2%</td>
        <td>2%</td>
        <td>2%</td>
        <td>2%</td>
        <td>2%</td>
        <td>2%</td>
        <td>2%</td>
        <td>3%</td>
      </tr>
      <tr style={{ textAlign: "center" }}>
        <td>การลดค่าใช้จ่ายด้านบุคลากร</td>
        <td>% ส่วนต่างของ คชจ.ด้านบุคลากรต่อรายได้</td>
        <td>%</td>
        <td>3.0%</td>
        <td>(0%)</td>
        <td>(1%)</td>
        <td>231%</td>
        <td>5</td>
        <td>(0%)</td>
        <td>(0%)</td>
        <td>(0%)</td>
        <td>(1%)</td>
        <td>(1%)</td>
        <td>(0%)</td>
        <td>(0%)</td>
        <td>(0%)</td>
        <td>(0%)</td>
        <td>(1%)</td>
        <td>(1%)</td>
        <td>(1%)</td>
      </tr>
      <tr className="table-collapse">
        <td
          style={{
            border: "none",
            background: "#e28f60",
            whiteSpace: "nowrap",
          }}
        >
          ทำระบบ IT ช่วยเพิ่มความเร็วในการทำงาน
        </td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
        <td style={{ border: "none", background: "#e28f60" }}></td>
      </tr>
      <tr style={{ textAlign: "center" }}>
        <td>BU : ระบบ Smart Production</td>
        <td>สัดส่วน Smart Operation (จำนวน core process งาน)</td>
        <td>%</td>
        <td>3.0%</td>
        <td>100%</td>
        <td>100%</td>
        <td>100%</td>
        <td>5</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>100%</td>
      </tr>
      <tr style={{ textAlign: "center" }}>
        <td>ขาย : ระบบ Smart Operation</td>
        <td>สัดส่วน Smart Production (จำนวน core process งาน)</td>
        <td>%</td>
        <td>2.0%</td>
        <td>100%</td>
        <td>100%</td>
        <td>100%</td>
        <td>5</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>100%</td>
      </tr>
    </table>
  );
}
